
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "membershipExists",
      resolverType: "query",
      routePath: "/membershipExists",
      httpMethod: "POST",
    });
  